<app-loading-spinner
    [active]="loading || loadingProfiles"></app-loading-spinner>

<ng-container *ngIf="loading">
    <ngx-skeleton-loader [theme]="{
        width: '100%',
        height: '150px'
      }">
    </ngx-skeleton-loader>

    <app-spacer [bottom]="24"></app-spacer>

    <ngx-skeleton-loader [theme]="{
        width: '100%',
        height: '300px'
      }">
    </ngx-skeleton-loader>
</ng-container>

<ng-container *ngIf="!loading">
    <div class="dash-card no-padding">
        <div
            class=" dash-card-header d-flex align-items-start justify-content-between">
            <h2>Vincular perfis de acesso</h2>
        </div>

        <div class="dash-card-body padding-container mb-5">
            <div class="col-12" style="padding: 0 30px 20px;">
                <div class="row">
                    <div class="col-lg-5">
                        <p class="title">Empresa</p>
                        <p class="label">
                            {{formatDocument(data?.document_number)}} |
                            {{data?.corporate_name}}
                        </p>
                    </div>

                    <div class="col-lg-2">
                        <p class="title">Papel</p>
                        <p class="label">
                            {{data?.role ?? '--'}}
                        </p>
                    </div>

                    <div class="col-lg-5">
                        <p class="title">Criado por</p>
                        <p class="label">
                            {{data?.owner ??
                            user.active_register.register.name}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="dash-card no-padding">
        <div class="dash-card-header d-block">
            <h2>Perfis de acesso</h2>
            <p>
                Utilize o controle abaixo para vincular os perfis de acessos
                que gostaria de associar a esta empresa
            </p>
        </div>

        <div class="dash-card-body padding-container mb-5">
            <div class="col-12 permission-container"
                style="padding: 0 30px 20px;">
                <div class="permission-container-header">
                    <div class="left pt-0" style="border:0;">
                        <h3>Perfis disponíveis</h3>
                        <app-spacer [bottom]="8"></app-spacer>

                        <div class="permission-container-header-search">
                            <svg-icon
                                src="assets/images/icon-search.svg"></svg-icon>
                            <app-spacer [right]="8"></app-spacer>
                            <app-input [group]="searchForm" style="width: 100%;"
                                controlName="avaliableProfiles"
                                [maxLength]="60">
                            </app-input>
                        </div>
                    </div>
                    <div class="right pt-0" style="border:0;">
                        <h3>Perfis escolhidos</h3>
                        <app-spacer [bottom]="8"></app-spacer>

                        <div class="permission-container-header-search">
                            <svg-icon
                                src="assets/images/icon-search.svg"></svg-icon>
                            <app-spacer [right]="8"></app-spacer>
                            <app-input [group]="searchForm" style="width: 100%;"
                                controlName="selectedProfiles" [maxLength]="60">
                            </app-input>
                        </div>
                    </div>
                </div>

                <div class="permission-container-body">
                    <div class="left">
                        <p class="permission-container-body-top-content">
                            {{avaliableCheckedNumber}} de
                            {{totalAvaliableOptions}} itens selecionados
                        </p>
                        <app-spacer [bottom]="16"></app-spacer>

                        <div class="permission-container-body-list">
                            <div class="permission-container-body-list-item"
                                *ngFor="let item of profilesAvaliable; let i = index">
                                <app-radio
                                    (onCheckChanged)="toggleValue(item,true)"
                                    [multiple]="true"
                                    [isChecked]="isOptionsChecked(item,true)">
                                    {{item.label}}
                                </app-radio>

                                <app-spacer [bottom]="16"></app-spacer>
                            </div>
                        </div>

                    </div>
                    <div class="buttons-container">
                        <button [disabled]="getDisabled(true)"
                            (click)="changeSide(true)">
                            <svg-icon
                                src="assets/images/icon-right.svg"></svg-icon>
                        </button>

                        <button [disabled]="getDisabled()"
                            (click)="changeSide()">
                            <svg-icon
                                src="assets/images/icon-left.svg"></svg-icon>
                        </button>
                    </div>
                    <div class="right">
                        <p class="d-flex">
                            {{selectedCheckedNumber}} de
                            {{totalSelectedOptions}} itens selecionados
                        </p>
                        <app-spacer [bottom]="16"></app-spacer>

                        <div class="permission-container-body-list">
                            <div class="permission-container-body-list-item"
                                *ngFor="let item of visibleProfilesSelected; let i = index">
                                <app-radio (onCheckChanged)="toggleValue(item)"
                                    [multiple]="true"
                                    [isChecked]="isOptionsChecked(item)">
                                    {{item.label}}
                                </app-radio>
                                <app-spacer [bottom]="16"></app-spacer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-between">
        <app-button (onClick)="handleCancel()" [disabled]="sendingRequest"
            [phantom]="true">
            Cancelar
        </app-button>

        <app-button (onClick)="handleAddBond()" class="add-button"
            [disabled]="getSubmitDisabled()" [loading]="sendingRequest">
            Salvar
        </app-button>
    </div>
</ng-container>